import { fromJS } from 'immutable';
import { ENTITY_NOT_FOUND, ENTITY_STATUS, ENTITY_LOAD_START, ENTITY_LOADING, ENTITY_LOADED, ENTITY_RESET, BREADCRUMBS_LOADED, ENTITY_LOADING_STATUS_START, ENTITY_LOADING_STATUS_LOADING, ENTITY_LOADING_STATUS_LOADED, ENTITY_LOADING_STATUS_ERROR } from '../../actions/Entity';
var initialState = fromJS({
  exists: false,
  breadcrumbs: [],
  loadingStatus: null
});
export default function entity() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case ENTITY_LOAD_START:
      {
        return state.set('loadingStatus', ENTITY_LOADING_STATUS_START);
      }

    case ENTITY_LOADING:
      {
        return state.set('loadingStatus', ENTITY_LOADING_STATUS_LOADING);
      }

    case ENTITY_LOADED:
      {
        return state.set('loadingStatus', ENTITY_LOADING_STATUS_LOADED).set('exists', true).set('entityId', action.entityId).set('entityType', action.entityType).set('canonical', action.canonical);
      }

    case ENTITY_RESET:
      {
        return state.set('loadingStatus', null).set('exists', true).set('entityId', null).set('entityType', null).set('canonical', null).set('status', null);
      }

    case ENTITY_NOT_FOUND:
      {
        return state.set('loadingStatus', ENTITY_LOADING_STATUS_ERROR).set('exists', false);
      }

    case ENTITY_STATUS:
      {
        return state.set('status', action.status);
      }

    case BREADCRUMBS_LOADED:
      {
        return state.set('breadcrumbs', fromJS(action.payload));
      }

    default:
      return state;
  }
}